import { RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomRecordingSetRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomRecordingSetRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomRecordingSetRequest) {
    JsonSchemaValidator.assert(RoomRecordingSetRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId"],
      properties: {
        roomId
      }
    };
  }
}

interface RoomRecordingSetRequest {
  roomId: RoomId;
}
